import { u as _, o as u, b as p, c as s, e as t, f as c, F as h, p as b, g as o, t as a, k as n } from "./define-element-XpjsV6s1.js";
import { a as y } from "./use-club-A3ZrZZcp.js";
import { _ as m } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const g = {
  ref: "container",
  class: "offset-clubs"
}, v = {
  key: 0,
  class: "offset-clubs-loading"
}, k = {
  key: 1,
  class: "offset-clubs-empty"
}, T = {
  key: 2,
  class: "offset-clubs-list"
}, L = { class: "offset-club-header" }, M = { class: "offset-club-name" }, S = { class: "offset-club-badges" }, H = {
  key: 0,
  class: "offset-club-badge"
}, C = {
  key: 1,
  class: "offset-club-badge"
}, j = ["innerHTML"], x = { class: "offset-club-details" }, B = ["innerHTML"], F = ["innerHTML"], I = ["innerHTML"], N = { class: "offset-club-footer" }, R = ["href"], U = {
  __name: "Clubs",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    joinUrl: {
      type: String,
      default: "/club/"
    },
    joinText: {
      type: String,
      default: "Join the Club"
    }
  },
  setup(i) {
    const l = i, { isPending: r, clubs: f } = y(), d = _("container");
    return u(() => {
      p(d.value, l.inheritStyle);
    }), (V, $) => (s(), t("div", g, [
      c(r) ? (s(), t("div", v, "Loading...")) : c(f).length ? (s(), t("div", T, [
        (s(!0), t(h, null, b(c(f), (e) => (s(), t("div", {
          key: e.id,
          class: "offset-club"
        }, [
          o("div", L, [
            o("h2", M, a(e.name), 1),
            o("div", S, [
              e.discount ? (s(), t("span", H, a(e.discount) + "% off", 1)) : n("", !0),
              e.free_shipping == "1" ? (s(), t("span", C, "Free shipping")) : n("", !0)
            ])
          ]),
          e.description ? (s(), t("p", {
            key: 0,
            class: "offset-club-description",
            innerHTML: e.description
          }, null, 8, j)) : n("", !0),
          o("div", x, [
            e.club_info_1 ? (s(), t("div", {
              key: 0,
              class: "offset-club-info offset-club-benefits",
              innerHTML: e.club_info_1
            }, null, 8, B)) : n("", !0),
            e.club_info_2 ? (s(), t("div", {
              key: 1,
              class: "offset-club-info offset-club-pricing",
              innerHTML: e.club_info_2
            }, null, 8, F)) : n("", !0),
            e.club_info_3 ? (s(), t("div", {
              key: 2,
              class: "offset-club-info",
              innerHTML: e.club_info_3
            }, null, 8, I)) : n("", !0)
          ]),
          o("div", N, [
            o("a", {
              class: "offset-club-join btn btn-primary",
              href: `${i.joinUrl}${e.id}/`
            }, a(i.joinText), 9, R)
          ])
        ]))), 128))
      ])) : (s(), t("div", k, "No clubs available."))
    ], 512));
  }
}, J = /* @__PURE__ */ m(U, [["__scopeId", "data-v-3e589952"]]);
export {
  J as C
};
